import type { AxiosResponse } from "axios";
import { api, buildStorefrontApiPath } from "@/lib/api";

// H3 — el gate de la tienda, la moneda y la config de checkout piden
// /bootstrap a la vez al arrancar. Con Slow 4G eran tres respuestas en fila
// (~1.1 s más hasta pintar el inicio). Se comparte el pedido en vuelo; cuando
// termina se suelta, así un pedido posterior vuelve a ir a la red.
const inflight = new Map<string, Promise<AxiosResponse<unknown>>>();

export function getStorefrontBootstrap<T = unknown>(
  orgSlug?: string | null,
): Promise<AxiosResponse<T>> {
  const path = buildStorefrontApiPath("/bootstrap", orgSlug);
  let pending = inflight.get(path);
  if (!pending) {
    pending = api.get(path).finally(() => inflight.delete(path));
    inflight.set(path, pending);
  }
  return pending as Promise<AxiosResponse<T>>;
}
